import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=2be6607f&scoped=true&"
import script from "./IconMenu.vue?vue&type=script&lang=js&"
export * from "./IconMenu.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./IconMenu.vue?vue&type=style&index=0&id=2be6607f&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2be6607f",
  null
  ,true
)

export default component.exports